import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
export default function JSONArrow(_ref) {
  let {
    styling,
    arrowStyle = 'single',
    expanded,
    nodeType,
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement("div", _extends({}, styling('arrowContainer', arrowStyle), {
    onClick: onClick
  }), /*#__PURE__*/React.createElement("div", styling(['arrow', 'arrowSign'], nodeType, expanded, arrowStyle), '\u25B6', arrowStyle === 'double' && /*#__PURE__*/React.createElement("div", styling(['arrowSign', 'arrowSignInner']), '\u25B6')));
}